import React from "react"
import {Alert, AlertTitle, Collapse, IconButton, Typography} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

const SpendToTheEndDisclaimer = ({
  expanded,
  onToggle,
}: {
  expanded: boolean
  onToggle: () => void
}) => {
  return (
    <Alert
      severity="info"
      sx={{mb: 1}}
      action={
        <IconButton
          size="small"
          aria-label={expanded ? "Collapse disclaimer" : "Expand disclaimer"}
          onClick={onToggle}
          sx={{
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 200ms",
          }}
        >
          <ExpandMoreIcon fontSize="small"/>
        </IconButton>
      }
    >
      <AlertTitle sx={{mb: 0}}>What Spend to the End shows you...</AlertTitle>
      <Collapse in={expanded}>
        <Typography variant="body2" sx={{mt: 1}}>
          The annual spending shown is a model-driven estimate that assumes constant returns,
          your stated inflation rate, and unchanged income through the projection. Real-world
          spending should account for variable returns (sequence-of-returns risk), unexpected
          expenses (long-term care, medical), and household composition changes &mdash; spending
          typically drops significantly after the death of a spouse. Use this projection as a
          starting point for planning conversations, not as a recommendation.
        </Typography>
      </Collapse>
    </Alert>
  )
}

export default SpendToTheEndDisclaimer
